function getIEVersion() {
    var userAgent = window.navigator.userAgent;

    var msie = userAgent.indexOf('MSIE ');
    if (msie > 0) {
        // IE 10 or older => return version number
        return +userAgent.substring(msie + 5, userAgent.indexOf('.', msie));
    }

    var trident = userAgent.indexOf('Trident/');
    if (trident > 0) {
        // IE 11 => return version number
        var rv = userAgent.indexOf('rv:');
        return +userAgent.substring(rv + 3, userAgent.indexOf('.', rv));
    }

    var edge = userAgent.indexOf('Edge/');
    if (edge > 0) {
       // IE 12 => return version number
       return +userAgent.substring(edge + 5, userAgent.indexOf('.', edge));
    }

    // other browser
    return 0;
}


/**
 * Returns true if the browser is IE
 */
function isIE() {
    return !!getIEVersion();
}
